import ClearIcon from '@mui/icons-material/Clear'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import { Modal } from '../../../../ui/Modal'
import CustomButton from '../../../../ui/CustomButton'

const impactItems = [
  {
    title: 'Acceso vigente',
    description: 'Podras seguir usando tu cuenta hasta el fin de la suscripcion actual.'
  },
  {
    title: 'Tarjetas eliminadas',
    description: 'Se eliminaran todas tus tarjetas guardadas al cancelar el plan.'
  },
  {
    title: 'Reactivacion simple',
    description:
      'Si quieres mantener el servicio, solo debes agregar una tarjeta antes del vencimiento.'
  },
  {
    title: 'Cierre definitivo',
    description:
      'Si la suscripcion termina y no agregas una tarjeta, la cuenta se eliminara permanentemente.'
  }
]

const CancelPlanModal = ({ isOpen, onClose, onConfirm, isPending }) => {
  const handleClose = () => {
    if (isPending) return
    onClose?.()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <div className='flex max-h-[80vh] w-[min(48rem,calc(100vw-2rem))] flex-col overflow-hidden rounded-xl bg-white shadow-2xl'>
        <div className='flex items-center justify-between bg-primary px-4 py-2 text-white sm:px-8'>
          <div>
            <p className='text-[11px] font-semibold uppercase tracking-[0.22em] text-white/70'></p>
            <h2 className='mt-1 text-2xl font-bold'></h2>
          </div>

          <button
            type='button'
            onClick={handleClose}
            className='rounded-full p-2 text-white transition-colors hover:bg-white/15 disabled:cursor-not-allowed disabled:opacity-50'
            disabled={isPending}
            aria-label='Cerrar modal'
          >
            <ClearIcon style={{ fontSize: 20 }} />
          </button>
        </div>

        <div className='flex-1 overflow-y-auto px-6 py-8 sm:px-8'>
          <div className='mx-auto flex max-w-3xl flex-col items-center text-center'>
            <div className='flex h-20 w-20 items-center justify-center rounded-full'>
              <ErrorOutlineOutlinedIcon style={{ fontSize: 40 }} />
            </div>

            <h3 className='mt-2 text-2xl font-sans font-bold text-slate-800'>
              Estas por cancelar tu plan
            </h3>

            <p className='mt-3 max-w-2xl font-sans text-sm leading-6 text-slate-600'>
              La cancelacion detiene la renovacion automatica, pero tu acceso seguira activo hasta
              el fin del periodo ya pagado.
            </p>
          </div>

          <div className='mx-auto mt-8 grid max-w-3xl gap-3 sm:grid-cols-2'>
            {impactItems.map(item => (
              <div
                key={item.title}
                className='rounded-2xl border border-slate-200 bg-slate-50/80 p-5 text-left shadow-sm'
              >
                <p className='text-xs font-sans font-semibold uppercase tracking-[0.18em] text-primary/80'>
                  {item.title}
                </p>
                <p className='mt-2 text-sm font-sans leading-6 text-slate-700'>
                  {item.description}
                </p>
              </div>
            ))}
          </div>

          <div className='mx-auto mt-8 max-w-2xl rounded-2xl border border-gray-200 bg-gray-50 px-5 py-4 text-center'>
            <p className='text-sm font-sans font-semibold'>
              Confirma solo si realmente quieres detener la renovacion de tu suscripcion.
            </p>
          </div>
        </div>

        <div className='flex flex-wrap justify-end gap-3 border-t border-slate-200 bg-slate-50 px-6 py-4 sm:px-8'>
          <CustomButton
            type='button'
            title='Volver'
            onClick={handleClose}
            color='primary'
            className='rounded-full px-5 py-2'
            disabled={isPending}
          />
          <CustomButton
            type='button'
            title={isPending ? 'Cancelando...' : 'Confirmar cancelacion'}
            onClick={onConfirm}
            color='accent3'
            className='rounded-full px-5 py-2'
            disabled={isPending}
          />
        </div>
      </div>
    </Modal>
  )
}

export default CancelPlanModal
